import React, { useState } from "react";
import { getDateFormat, getShopFromOrder } from "../../../utils";
import { ORDER_PHASE } from "../../../constants";
import { ChevronRight } from "@mui/icons-material";
import OrderDetailModal from "./OrderDetailModal";
import OrderStatusIndicator from "./OrderStatusIndicator";
import { Typography, Box } from "@mui/material";
import renderOrderType from "../components/orderType";
import getStyles from "../Order.styles";
import { useNavigate } from "react-router-dom";
import { ORDER_TRACKING_ROUTE } from "../../../constants/routes";
import { OrderItemImages } from "../components/OrderItemImages";

type OrderDetailProps = {
  order: any;
  showFees: boolean;
  deleteOption: boolean;
  isMobile?: boolean;
};

export default function OrderDetail({
  order,
  showFees,
  deleteOption,
  isMobile,
}: OrderDetailProps) {

  const [open, setOpen] = useState(false);
  const styles = getStyles()
  const { date, commande, status, orderType, totalPriceOrder, orderNumber } = order;


  const shop = getShopFromOrder(order);
  const { name } = shop;
  const navigate = useNavigate();
  const isPastOrder = !!(
    status === ORDER_PHASE.COMPLETED ||
    status === ORDER_PHASE.REFUND ||
    order.cancellation
  );

  const totalPrice = order?.totalPriceOrder || 0;


  return (
    <>
      <Box
        sx={styles.container}
        onClick={() =>
          isPastOrder
            ? setOpen(true)
            : navigate(ORDER_TRACKING_ROUTE, {
              state: { chargeId: order?.chargeId },
            })
        }
      >


        <div style={styles.content}>
          <div style={styles.row}>
            <div style={styles.left}>
              <Typography variant="body1" sx={styles.textWrap}>
                {name}
              </Typography>
            </div>

            <div style={styles.right}>{renderOrderType(orderType)}</div>
          </div>

          <div style={styles.row}>
            <div style={styles.left}>
              <Typography
                variant={isMobile ? "subtitle2" : "h5"}
                sx={styles.textWrap}
              >
                Commande n°{orderNumber} du {getDateFormat(date)}
              </Typography>
            </div>

            <div style={styles.right}>
              <ChevronRight
                onClick={() =>
                  isPastOrder
                    ? setOpen(true)
                    : navigate(ORDER_TRACKING_ROUTE, {
                      state: { order },
                    })
                }
                style={styles.chevron}
              />
            </div>
          </div>

          <div style={styles.row}>
            <div style={styles.left}>
              <OrderItemImages
                commande={commande}
                totalPrice={totalPriceOrder}
              />
            </div>

            <div style={styles.right}>
              <OrderStatusIndicator order={order} isMobile={isMobile} isPast={isPastOrder} />
            </div>
          </div>
        </div>
      </Box>
      {open && (
        <OrderDetailModal
          open={open}
          onClose={() => setOpen(false)}
          order={order}
          showFees={showFees}
          deleteOption={deleteOption}
          orderType={orderType}
          totalPrice={totalPrice}
          isMobile={isMobile}
          isPastOrder={isPastOrder}
        />
      )}
    </>
  );
}
